<template >
    <div class="bg-gray-600 rounded-md">

        <div class="mb-1 text-base font-medium text-racing-stars-yellow text-left">Step 13 of 14</div>
        <div class="w-full bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700 ">
        <div class="bg-gradient-to-r from-racing-stars-yellow to-yellow-200 h-2.5 rounded-full" :style="{ 'width': 7.142857143 * 13 + '%' }"></div>
        </div>

        <p class="text-center max-w-sm mx-auto">Pick the <b class="text-racing-stars-yellow">'Double Points'</b> booster for your runner.</p>

        <button type="button" :v-model="tutorialStep" @click="$emit('updateTutorialStep', 14);"
            class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
            Next step
        </button>
    </div>
</template>

<script>
import Popper from 'vue3-popper'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type: Number,
        },
        selections: {
            type: Object,
        },
    },

    emits: ['updateTutorialStep'],

    setup(props, { emit }) {
        const updateTutorialStep = (tutorialStep) => {
            localStorage.setItem('tutorialStep', '')

            emit('updateTutorialStep', tutorialStep)
        }

        const getExp = () => {
            axios.get(route('api.tutorial.get'))
                .then(response => {
                    level.value = response.data
                })
        }

        return {
            getExp,
            updateTutorialStep,
        }
    },

    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronUpIcon,
        ChevronDownIcon,

    },
}

</script>
